import api from '../axios'
import Cookies from 'universal-cookie';

const cookies = new Cookies();
//
//-> Authentications
//
// making an account
export const register = (formValues) => {
  api.post('user/register', {
    username: formValues.username,
    email: formValues.email.toLowerCase(),
    password: formValues.password
  })
  .then(res => {
    alert(res.data)
    window.location.href = "/login"
  })
  .catch(err => {
    alert(err.response.data)
  })
};
// logging into existing account
export const login = (formValues) => {
  api.post('user/login', {
    email: formValues.email.toLowerCase(),
    password: formValues.password
  })
  .then((res) => {
    cookies.set('token', res.data, { path: '/' });
    window.location.href = "/"
  })
  .catch(err => {
    alert(err.response.data)
  })
};
// Logging out of account
export const logout = async () => {
  await cookies.remove("token", {
    domain: "localhost:3000"
  });
  alert('Logged out')
  window.location.reload();
};
//
// -> Contacts
//
// Add contacts
export const addContact = (name, number) => {
  api.post('contact', {
      name,
      number
  })
  .then(() => {
      // After texts sends were refreshing the contacts
      window.location.reload()
  })
  .catch(err => {
      alert(err.response.data)
  })
}
// Edit contacts
export const editContact = (id, name, number) => {
  api.put(`contact/${id}`, {
      name,
      number
  })
  .then(() => {
      // After contacts edited were refreshing the contacts
      window.location.reload()
  })
  .catch(err => {
      alert(err.response.data)
  })
}
// Delete contacts
export const deleteContact = (id) => {
  api.delete(`contact/${id}`)
  .then(() => {
      // After deleted were refreshing the contacts
      window.location.reload()
  })
  .catch(err => {
      alert(err.response.data)
  })
}
// Refetch SF Contacts
export const sfContacts = () => {
  api.post(`contacts/salesforce`)
  .then(() => {
      // After deleted were refreshing the contacts
      window.location.reload()
  })
  .catch(err => {
      alert(err.response.data)
  })
}
//
// -> Templates
//
// Add templates
export const addTemplate = (title, message, media) => {
  api.post('template', {
      title,
      message,
      media
  })
  .then(() => {
      // After texts sends were refreshing the contacts
      window.location.reload()
  })
  .catch(err => {
      alert(err.response.data)
  })
}
// Delete templates
export const deleteTemplate = (id) => {
  api.delete(`template/${id}`)
  .then(() => {
      // After deleted were refreshing the contacts
      window.location.reload()
  })
  .catch(err => {
      alert(err.response.data)
  })
}
//
//-> Send message
//
// Send SMS
export const sendSMS = (number, message) => {
  if (!number) {
    alert('No recipient found, templates send to the chat on the right')
  } else {
    api.post('send/SMS', {
        to: number,
        message: message
    })
    .catch(err => {
        alert(err.response.data)
    })
  }
}
// Send MMS
export const sendMMS = (number, message, media) => {
  if (!number) {
      alert('No recipient found, templates send to the chat on the right')
  } else {
    api.post('send/MMS', {
        to: number,
        message,
        media,
    })
    .catch(err => {
        alert('Bad request, try again!')
    })
  }
}